const backEndPath = "https://ud-prototype-dashboard-back.netlify.app/.netlify/functions/api/";
// const backEndPath = "http://localhost:8888/.netlify/functions/api/";

export { backEndPath };
